import { useCallback, useEffect, useState } from "react";
import { tss } from "tss-react";
import { Scrollbars } from "react-custom-scrollbars";
import { 
    Grid2 as Grid, 
    CardContent, 
    Button, 
    Typography, 
    Container,
    Tab
} from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { JumboCard } from 'themes/jumbo/@jumbo/components';
//import { SortByAlpha, FilterList, Tv, Photo } from "@mui/icons-material";
import { Tv } from "@mui/icons-material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import themeCfg from "config/theme.json";
import { getCachedData } from "api/Cache";
import AddViewPanel from "panels/AddViewPanel";
import { BreadCrumbs, ViewCard, CircularProgressWithLabel } from "components";
import { sortArrayByProp, StorageUtils } from "services/UtilsService";
import EventsEmitter from "events/EventsEmitter";
import commonStyles from "styles/common";
import viewsStyles from "styles/views";
import AddIcon from '@mui/icons-material/Add';
import SortIcon from '@mui/icons-material/Sort';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'utils/@lodash';
import './Views.css';
import SubscriptionDialog from 'components/SubscriptionDialog';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { trackEvent } from "components/Tracking";
import {
    closeNewDialog
} from 'store/projects';
import { useParams } from "react-router-dom";

const useStyles = tss.create(() => ({
    root: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        height: "100%",
    },
    content: {
        position: "relative",
        paddingLeft: 0,
        height: "calc(100% - 50px)",
        backgroundColor: "#f7f7f7",
    },
    viewCard: {
        display: "inline-flex",
        width: 240,
        height: 180,
        padding: 10,
        justifyContent: "center",
        backgroundColor: "white",
    },
    link: {
        textDecoration: "none",
        color: "grey",
    },
    icon: {
        marginLeft: 25,
        cursor: "pointer",
    },
    trackhorizontal:{
        backgroundColor : 'red'
    },
    sortPanel:{
        height:'120px',  
        justifyContent:'space-evenly',  
        cursor : 'default',
        background: '#fff', 
        position:'absolute', 
        alignItems:'flex-end',
        top:'44px', 
        right:0, 
        display: 'flex', 
        flexDirection:'column', 
        zIndex:1,
        width:'138px',
        // borderTop: '1px solid rgba(0,0,0, 0.1)',
       // boxShadow: '0px 8px 10px #00000020, -10px 8px 15px #00000020, 10px 8px 15px #00000020'

    },
    sortItemContainer:{
        width: '100%',
        display:'flex',
        color: '#000',
        fontSize: '14px'
    },
    sortItemLabel:{
        textDecoration : 'none',
        background: 'transparent',
        cursor: 'pointer',
        width:'100%',
        border: 0,
        textAlign:'right',
        fontSize : '1rem'
    },
    sortLabel:{
        margin: "0 8px"
    },
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto',
        width: 'unset',
        minWidth: '30px',
        minHeight: '30px',
    }
}));

const AddView = (props: { setNewView: any }) => {
    const { setNewView } = props;
    const createView = () => {
        setNewView(true);
    };
    return (
        <div
            style={{
                width: 256,
                height: "auto",
                minHeight: 256,
                marginLeft: 14,
                marginRight: 0,
                marginBottom: 16,
                padding:10,
                borderRadius:10,
                marginTop: 10,
                backgroundColor: "#f7f7f7",
                overflowY: "hidden",
                display:'none'
            }}
        >
            <CardContent
                style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    marginTop: 40,
                    height: "100%",
                    cursor: "pointer",
                }}
                onClick={createView}
            >
                <Tv style={{ width: 128, height: 128, color: "silver" }} />
                <Button size="large" variant="contained" color="secondary">
                    New View
                </Button>
            </CardContent>
        </div>
    );
};
export default function Views() {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    //const data = getCachedData();

    const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || "all");
    //const [sort, setSort] = useState(false);
    const [sortName, setSortName] = useState(false);
    const [sortDate, setSortDate] = useState(false);
    const [newView, setNewView] = useState(false);
    const [count, setCount] = useState(40);
    const [storeViews, setStoreViews] = useState([]);
    const [views, setViews] = useState([]);
    const [showThumbnail, setShowThumbnail] = useState(false);
    const [progress, setProgress] = useState(0);
    const [sortKey, setSortKey] = useState('name');
    const [sortOpened, setSortOpened] = useState(false)
	const storeCachedData = useSelector((state: any) => state.cache);
    const { update:cacheUpdateTime, data } = storeCachedData;
	const storeAuthData = useSelector((state: any) => state.auth);
    const [hasFullAccess, setHasFullAccess] = useState(false);
    const { hasActiveSubscription = false, projectAccessLevel:access_level = "read", activeProject, isDefaultProject = false, defaultProjects } = storeAuthData;
    const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
	const storeProjectsData = useSelector((state: any) => state.projects);
    const { dialogBox } = storeProjectsData
    const { defaultTab } = useParams();
    const [tabValue, setTabValue] = useState(defaultTab || 'myviews');
    const dispatch = useDispatch();
    
    useEffect(() => {
        dialogBox.type === 'homenewview' &&  setNewView(true);
    }, [dialogBox.type, setNewView])

    useEffect(() => {
        setHasFullAccess(hasActiveSubscription && access_level === (!!activeProject ? 'full' : 'read'))
    }, [activeProject, access_level, hasActiveSubscription])

    useEffect(() => {
        let _views = JSON.parse(JSON.stringify(data.views));
        if (_.isEqual(storeViews, _views)) return;
        _views = Object.values(_views).filter((item: any) => tabValue === 'myviews' ? !defaultProjects.includes(item.project) : defaultProjects.includes(item.project)); 

        setStoreViews(_views)
    }, [data.views, tabValue])

    const getFilteredViews = useCallback(
        (filter: string) => {
            const views = storeViews;
            let remainsList = [];
       
            let resultArray : any = Object.values(views);
            let viewsArray: any = Object.values(views);
            
            //console.log(viewsArray)
            if (filter !== "all") {
                var filterArr = filter.split(",");
                viewsArray = viewsArray.filter((entries: any) => filterArr.includes(entries.project));
                resultArray = viewsArray;
            }

            if(sortKey === 'name'){
                viewsArray = sortArrayByProp(resultArray, "name", sortName);
            }
            else  if(sortKey === 'date'){
                viewsArray = sortArrayByProp(resultArray, "file_date", sortDate);
            }
            else{
                if (showThumbnail) {
                    viewsArray = resultArray.filter((view: any) => view["has_thumbnail"] === "1");
                    remainsList = resultArray.filter((view: any) => typeof view["has_thumbnail"] === "undefined");
                    viewsArray = [...viewsArray, ...remainsList]
    
                }else if(!showThumbnail){
                    viewsArray = resultArray.filter((view: any) => typeof view["has_thumbnail"] === "undefined");
                    remainsList = resultArray.filter((view: any) => view["has_thumbnail"] === "1");
                    viewsArray = [...viewsArray, ...remainsList]
                }
            }
            setViews(viewsArray);
        },
        [storeViews, sortName, sortDate, sortKey, showThumbnail]
    );

    useEffect(() => {
        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        const updateFilter = (curFilter: string) => {
            setFilter(curFilter);
            getFilteredViews(curFilter);
        };
        getFilteredViews(filter);
        EventsEmitter.on("updateFilter", updateFilter);
        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("updateFilter", setFilter);
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };
    }, [filter, getFilteredViews]);

    useEffect(() => {
        getFilteredViews(filter);
    }, [filter, getFilteredViews]);

    if (!data.loaded) {
        return <CircularProgressWithLabel className={classes.CircularProgress} value={progress || 0} />;

    }

    const handleClose = () => {
        setNewView(false);
        dispatch(closeNewDialog())
    };

    const toggleVisibleViews = () => {
       setShowThumbnail(!showThumbnail);
       setSortKey('thumbnail')
    };

    const sortAlpha = (val:any) => {
        setSortKey(val)
        console.log("Val : " + val)
        if(val === 'name')
            setSortName(!sortName);
        if(val === 'date')
            setSortDate(!sortDate);
    };

    const onScroll = () => {
        const increment = 20;
        setCount((prevCount) => (prevCount + increment < views.length ? prevCount + increment : views.length));
    };

    const closeSortPanel = (e : any) => {
        const elem: any = document.getElementById('sortElem');
        if (!elem.contains(e.target))
            setSortOpened(false)
    }

    const NewViewBtn = (props: { onClick? : () => void}) => {
        const { onClick } = props;

        return (
            <div 
                onClick={(ev: any) => {
                    trackEvent("Views", "Create View", "Btn");
                    ev.stopPropagation();
                    //setNewView(false);
                    if (onClick) {
                        onClick();
                    } else {
                        setNewView(true);
                    }
                }}
            >
                <Button 
                    sx={{
                        color: 'common.white',
                        bgcolor: '#5AADE3',
                        //transform: 'scale(.85)',
                        '&:hover': {
                            bgcolor: '#2196f3',
                        },
                        ml: 'auto'
                    }}
                    variant="contained" 
                    startIcon={<AddIcon fontSize="small"/>}
                    size="small"
                >
                    Create View
                </Button>
            </div>
        );
    }
      
    return (
        <div className={viewsClasses.root} onClick={(e) => closeSortPanel(e)}>
            <div className={classes.content}>
                <TabContext value={tabValue}>
                    <Div sx={{display:'flex', justifyContent:'space-between'}}>
                        <TabList
                            sx={{ borderColor: 'divider', mb: '40px' }}
                            onChange={(event, newValue) => setTabValue(newValue)}
                        >
                            <Tab
                                label={'MY VIEWS'}
                                value={'myviews'}
                                sx={{ minWidth: 200, fontSize: '16px' }}
                            />
                            <Tab label={'DEMOS'} value={'demos'} sx={{ minWidth: 200, fontSize: '16px' }} />
                        </TabList>
                        <Div style={{display:"flex", paddingRight: '20px', marginLeft: 'auto'}}>
                            <div id="sortElem" style={{marginLeft: 'auto', position:'relative'}} >
                                <Button 
                                    onClick={() => {
                                        trackEvent("Views", "Sort By", "Btn");
                                        setSortOpened(!sortOpened);
                                    }} 
                                    style={{backgroundColor: '#fff', color:'#000'}} 
                                    variant="contained" 
                                    size="small"
                                    startIcon={<SortIcon fontSize="small"/>} 
                                    endIcon={sortOpened ? <KeyboardArrowUpIcon fontSize="small"/> : <KeyboardArrowDownIcon fontSize="small"/>}>
                                    Sort By
                                </Button>
                                {
                                sortOpened ?
                                
                                    <div className={classes.sortPanel} id="sortPanel">
                                        {
                                        sortKey === 'name' ?
                                        <>
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('name')}>
                                                {
                                                sortName ?
                                                    <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowDownwardIcon style={{fontSize:'14px'}} /> }>Name</Button>
                                                :
                                                    <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowUpwardIcon style={{fontSize:'14px'}} />}>Name</Button>
                                                }
                                            </div>
                                            
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('date')}>
                                                <Button style={{color:'#000'}} fullWidth>Date</Button>
                                            </div> 
                                            <div className={classes.sortItemContainer} onClick={toggleVisibleViews}>
                                                <Button style={{color:'#000'}} fullWidth>Thumbnail</Button>
                                            </div> 
                                        </>
                                        :
                                        sortKey === 'date' ?
                                        <>
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('name')}>
                                                <Button style={{color:'#000'}} fullWidth>Name</Button>
                                            </div>
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('date')}>
                                            {
                                                sortDate ?
                                                    <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowDownwardIcon style={{fontSize:'15px'}} /> }>Date</Button>
                                                :
                                                    <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowUpwardIcon style={{fontSize:'15px'}} />}>Date</Button>
                                            }
                                            </div>
                                            <div className={classes.sortItemContainer} onClick={toggleVisibleViews}>
                                                <Button style={{color:'#000'}} fullWidth>Thumbnail</Button>
                                            </div> 
                                        </>
                                        :
                                        <>
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('name')}>
                                                <Button style={{color:'#000'}} fullWidth>Name</Button>
                                            </div>
                                            <div className={classes.sortItemContainer} onClick={() => sortAlpha('date')}>
                                                <Button style={{color:'#000'}} fullWidth>Date</Button>
                                            </div> 

                                            <div className={classes.sortItemContainer} onClick={toggleVisibleViews}>
                                                {showThumbnail ?
                                                    <Button fullWidth style={{color: themeCfg.sideTopColor}} endIcon={<ArrowDownwardIcon style={{fontSize:'15px'}} /> }>Thumbnail</Button>
                                                :
                                                    <Button fullWidth style={{color: themeCfg.sideTopColor}} endIcon={<ArrowUpwardIcon style={{fontSize:'15px'}} />}>Thumbnail</Button>
                                                }
                                            </div> 
                                        </>
                                        }
                                    </div> 
                                    :""
                                }                   
                            </div>
                            <div style={{width:'15px'}}></div>
                            { hasFullAccess ? <NewViewBtn /> : <SubscriptionDialog Component={NewViewBtn} /> }
                        </Div>    
                    </Div>
                    <TabPanel value='myviews' sx={{ p: 0, height: '100%' }}>
                        <Scrollbars
                            autoHeight
                            autoHeightMax={"calc(100vh - 200px)"}
                            style={{ overflowX: "hidden"}}
                            onScroll={onScroll}
                        >
                            <Container
                                maxWidth={false}
                                sx={{
                                //maxWidth: CONTAINER_MAX_WIDTH,
                                    display: 'flex',
                                    minWidth: 0,
                                    flex: 1,
                                    flexDirection: 'column',
                                    p: '0 20px 20px'
                                }}
                                className="views-grid-container"
                                disableGutters
                                >
                                    <Grid container spacing={3.75}>
                                        { views.length ? 
                                            views.map((view: any, index: number) => (
                                                <Grid  size={{ xs:12, sm: 6, md: 4, lg: 3, xl: 2 }} key={"views-" + index}>
                                                    <ViewCard view={view} />
                                                </Grid>
                                            )) : (
                                                <Typography
                                                    fontSize={'18px'}
                                                    variant={'body1'}
                                                    color={'text.secondary'}
                                                    sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', width: '100%'}}
                                                >
                                                    No views found
                                                </Typography>
                                            )
                                        }
                                    </Grid>
                            </Container>
                        </Scrollbars>
                    </TabPanel>
                    <TabPanel value='demos' sx={{ p: 0, height: '100%' }}>
                        <Scrollbars
                            autoHeight
                            autoHeightMax={"calc(100vh - 250px)"}
                            style={{ overflowX: "hidden"}}
                            onScroll={onScroll}
                        >
                            <Container
                                maxWidth={false}
                                sx={{
                                //maxWidth: CONTAINER_MAX_WIDTH,
                                    display: 'flex',
                                    minWidth: 0,
                                    flex: 1,
                                    flexDirection: 'column',
                                    p: '0 20px 20px'
                                }}
                                className="views-grid-container"
                                disableGutters
                                >
                                    <Grid container spacing={3.75}>
                                        <AddView setNewView={setNewView} />
                                        { views.length ? 
                                            views.map((view: any, index: number) => (
                                                <Grid  size={{ xs:12, sm: 6, md: 4, lg: 3, xl: 2 }} key={"views-" + index}>
                                                    <ViewCard view={view} />
                                                </Grid>
                                            )) : (
                                                <Typography
                                                    fontSize={'18px'}
                                                    variant={'body1'}
                                                    color={'text.secondary'}
                                                    sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', width: '100%'}}
                                                >
                                                    No views found
                                                </Typography>
                                            )
                                        }
                                    </Grid>
                            </Container>
                        </Scrollbars>
                    </TabPanel>
                    <AddView setNewView={setNewView} />
                </TabContext>
            </div>
            {newView ? <AddViewPanel handleClose={handleClose} /> : ""}
        </div>
    );
}
